import { useState } from 'react'
import { Box } from '@chakra-ui/react'

import { OfferCestovkoColumn } from './OfferCestovkoColumn'
import { ISelectedRisk, OfferGridProvider } from '../../../context/OfferGridContext'
import { OfferCestovkoHeaderColumn } from './OfferCestovkoHeaderColumn'
import { useCestovkoOffersContext } from '../../../context/CestovkoOffersProvider'
import { SortBy } from '../../../context/OffersProvider'
import { sortByValidFirst } from '../OffersCarList'
import { LoadingOverlay } from '../../../components/LoadingOverlay'
import { Loading } from '../../../components/Loading'
import { OfferHeaderColumnWrapper } from './components/OfferHeaderColumnWrapper'
import { OffersGrid } from './components/OffersGrid'

export const OfferCestovkoGrid = () => {
  const [openedColumns, setOpenedColumns] = useState<string[]>([])
  const [selectedRiskIds, setSelectedRiskIds] = useState<ISelectedRisk[]>([])

  const { offers, sortBy, showAll, isLoading } = useCestovkoOffersContext()
  const [isScrolled, setIsScrolled] = useState(false)

  const handleSectionTitleClick = (sectionId: string) => {
    let newColumns = []

    if (openedColumns.includes(sectionId)) {
      newColumns = openedColumns.filter((column) => column !== sectionId)
    } else {
      newColumns = [...openedColumns, sectionId]
    }

    setOpenedColumns(newColumns)
  }

  const filtered = offers.filter((x) => showAll || x.included)
  var sorted = filtered

  switch (sortBy) {
    case SortBy.Price:
      sorted = sortByValidFirst(sorted, (a, b) =>
        !!a.price && (!b.price || a.price < b.price) ? -1 : 1,
      )
      break

    case SortBy.Insurer:
      sorted = sortByValidFirst(sorted, (a, b) => a.insurerName.localeCompare(b.insurerName))
      break

    default:
      break
  }

  const handleIsScrolled = (isScrolled: boolean) => {
    setIsScrolled(isScrolled)
  }

  return (
    <OfferGridProvider
      openedColumns={openedColumns}
      onSectionTitleClick={handleSectionTitleClick}
      risks={selectedRiskIds}
      setRisks={setSelectedRiskIds}
    >
      {(!sorted || sorted.length == 0) && isLoading && <Loading large={true} />}

      {sorted && sorted.length > 0 &&
        <OffersGrid onIsScrolled={handleIsScrolled}>
          <OfferHeaderColumnWrapper isScrolled={isScrolled}>
            <OfferCestovkoHeaderColumn />
          </OfferHeaderColumnWrapper>

          <Box>
            {/* <OfferCompleteness passed={passed} /> */}

            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
              {sorted.map((offer) => (
                <LoadingOverlay key={offer.offerId}>
                  <OfferCestovkoColumn offer={offer} />
                </LoadingOverlay>
              ))}
            </Box>
          </Box>
        </OffersGrid>
      }
    </OfferGridProvider>
  )
}